import { createResourceCacheModel } from './cacheModel/cacheModel';
export var defaultCacheModelOptions = {
    defaultInvalidator: 24 * 60 * 60 * 1000 * 365,
    defaultPurger: 60 * 1000,
    defaultRequestPolicy: (typeof window === 'undefined'
        ? 'loadOnce'
        : 'loadInvalidated'),
};
var defaultTypesCounter = 0;
export function getNextDefaultBucket() {
    return "_anonymous_resource_" + ++defaultTypesCounter + "_";
}
var defaultCacheModel;
export function getDefaultCacheModel() {
    if (!defaultCacheModel) {
        defaultCacheModel = createResourceCacheModel();
    }
    return defaultCacheModel;
}
export function setDefaultCacheModel(cacheModel) {
    defaultCacheModel = cacheModel;
}
//# sourceMappingURL=defaults.js.map